import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgressBar from "./components/ScrollProgressBar";
import Home from "./pages/Home";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import PoliticaCookies from "./pages/PoliticaCookies";
import InformacoesLegais from "./pages/InformacoesLegais";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollProgressBar />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/informacoes-legais" element={<InformacoesLegais />} />
        </Routes>
        <Footer />
        <CookieConsent />
        <ScrollToTop />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
